import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Info icon — circled `i` tooltip glyph. */
const InfoIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M16.166 10.001C16.166 6.59533 13.4056 3.83416 10 3.83398C6.59424 3.83398 3.83301 6.59522 3.83301 10.001C3.83318 13.4066 6.59435 16.167 10 16.167C13.4055 16.1668 16.1658 13.4065 16.166 10.001ZM9.5 12.667V10.001C9.5 9.72483 9.72386 9.50098 10 9.50098C10.276 9.50115 10.5 9.72494 10.5 10.001V12.667C10.5 12.943 10.276 13.1668 10 13.167C9.72386 13.167 9.5 12.9431 9.5 12.667ZM10.0059 6.83398C10.282 6.83398 10.5059 7.05784 10.5059 7.33398C10.5059 7.61013 10.282 7.83398 10.0059 7.83398H10C9.72386 7.83398 9.5 7.61013 9.5 7.33398C9.5 7.05784 9.72386 6.83398 10 6.83398H10.0059ZM17.166 10.001C17.1658 13.9588 13.9578 17.1668 10 17.167C6.04207 17.167 2.83318 13.9589 2.83301 10.001C2.83301 6.04294 6.04196 2.83398 10 2.83398C13.9579 2.83416 17.166 6.04304 17.166 10.001Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoIcon;
